<template>
    <div class="o-news">
        <div class="container">
            <div class="o-news__header pt-3 pb-3 pb-md-0">
                <div class="row align-items-center">
                    <div class="col-4 order-1">
                        <bread-crumbs
                            force-default-url
                            :default-url="'my-business'"
                        />
                    </div>
                </div>
            </div>

            <div class="o-news__list">
                <div class="row">
                    <div class="col-lg-3 d-flex flex-column mb-0 mb-md-3">
                        <the-filters
                            module-name="newsletters"
                            :filters="filters"
                            @applyFilters="applyFilters"
                        />
                    </div>
                    <div class="col-lg-9">
                        <div class="c-settings pt-1 mb-0">
                            <sub-section-header title="Wiem więcej"/>
                            <div
                                v-if="areNewsletters"
                                class="c-settings-filters ml-auto"
                            >
                                <sort-component
                                    module-name="newsletters"
                                    :text="'Sortuj po:'"
                                    :options="$store.getters.getNewslettersSortOptions"
                                    @onChange="fetchInit"
                                />
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between gap-1">
                            <header-tabs
                                class="mt-3 mb-3 mb-md-4"
                                style="flex: 1"
                                :content="headerTabs"
                            />
                        </div>

                        <selected-filters
                            class="mb-3 mb-md-4 mt-0"
                            module-name="newsletters"
                            :filters="filters"
                            @applyFilters="applyFilters"
                        />
                        <page-preloader
                            v-if="status === 'loading' && initialLoader"
                            :is-loading="true"
                            min-height="50vh"
                        />

                        <template v-else-if="areNewsletters">
                            <template v-if="activeTab === 0">
                                <newsletter-grid
                                    class="mb-5"
                                    show-new-badge
                                    :list="newsletters.slice(0, initialLimit)"
                                />

                                <h4
                                    v-if="
                                        pagination.total > initialLimit &&
                                            newsletters.length <= initialLimit
                                    "
                                    class="text-center cursor-pointer mb-5"
                                    @click="pagination.count === initialLimit && fetchMore()"
                                >
                                    Pokaż więcej
                                    <a-icon
                                        style="position: relative; top: 4px"
                                        icon="Dropdown"
                                    />
                                </h4>
                                <newsletter-grid
                                    type="list"
                                    class="fetch-more mb-5"
                                    show-new-badge
                                    :list="newsletters.slice(initialLimit)"
                                />
                            </template>

                            <template v-else>
                                <newsletter-grid
                                    type="list"
                                    class="fetch-more mb-5"
                                    :list="newsletters"
                                />
                            </template>
                            <page-preloader
                                v-if="status === 'loading' && fetchMoreLoader"
                                min-height="216px"
                                :is-loading="true"
                            />
                        </template>
                        <div
                            v-else
                            v-text="'Brak wyników'"
                            class="mt-3 mb-5"
                            style="min-height: 35vh;"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsletterGrid from '@/components/newsletters/NewsletterGrid.vue'

export default {
    data() {
        return {
            initialLimit: 6,
            initialLoader: false,
            fetchMoreLimit: 10,
            fetchMoreLoader: false,
            activeTab: 0
        }
    },
    components: {
        NewsletterGrid
    },
    methods: {
        fetch(params) {
            if (this.activeTab === 1) {
                params.limit = 20
            }
            return this.$store.dispatch('loadNewsletters', {
                ...params,
                archival: this.activeTab === 1
            })
        },
        async fetchInit() {
            this.initialLoader = true
            await this.fetch({ limit: this.initialLimit, offset: 0 })
            this.initialLoader = false
        },
        async fetchMore() {
            this.fetchMoreLoader = true
            await this.fetch({
                append: true,
                limit: this.fetchMoreLimit,
                offset: this.newsletters.length
            })
            this.fetchMoreLoader = false
        },
        async handleScroll() {
            if (this.status === 'loading') return
            if (
                this.newsletters.length <
                this.initialLimit + this.fetchMoreLimit
            ) {
                return
            }
            if (this.pagination.total === this.newsletters.length) return

            const windowHeight = window.innerHeight
            const newsletterGrid = document.querySelector('.fetch-more')
            if (!newsletterGrid) return

            const newsletterGridRect = newsletterGrid.getBoundingClientRect()
            const triggerPoint = windowHeight * 0.75

            if (newsletterGridRect.bottom <= triggerPoint) {
                this.fetchMoreLoader = true
                await this.fetchMore()
                this.fetchMoreLoader = false
            }
        },
        applyFilters() {
            this.fetchInit()
        }
    },
    computed: {
        newsletters() {
            return this.$store.getters.getNewsletters
        },
        pagination() {
            return this.$store.getters.getNewslettersPagination
        },
        areNewsletters() {
            return this.newsletters && this.newsletters.length
        },
        status() {
            return this.$store.getters.getNewslettersStatus
        },
        searchResultCounter() {
            return this.$store.getters.getNewslettersSearchResultCount
        },
        headerTabs() {
            return [
                {
                    text: 'Aktualne',
                    hash: '#current',
                    counter: this.searchResultCounter.current
                },
                {
                    text: 'Archiwalne',
                    hash: '#archival',
                    counter: this.searchResultCounter.archival
                }
            ]
        },
        filters() {
            return this.$store.getters.getNewslettersFilters
        }
    },
    created() {
        if (this.$route.hash && this.$route.hash === '#archival') {
            this.activeTab = 1
        }

        this.fetchInit()
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
